import './FileUploader.css';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TemplateModal from '../../components/TemplateModal/TemplateModal';
import { vector } from '../../_config/layers';
import CSVUploader from './components/CSVUploader/CSVUploader';
import KMLUploader from './components/KMLUploader';
import ShapeUploader from './components/ShapeUploader';
import { Button } from 'primereact/button';

function FileUploader(props) {
  const { t } = useTranslation();
  const htmlElement = useRef();
  const [active, setActive] = useState(0);

  const handleFileUploaderClick = () => {
    vector.getSource().clear();
    setActive(prev => prev + 1);
  };

  const closeModal = () => {
    setActive(false);
  };

  return (
    <div id="FileUploader" className="FileUploader">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('fileUploader.title')}
        title={t('fileUploader.title')}
        onClick={handleFileUploaderClick}
        ref={htmlElement}
        icon="pi pi-upload"
      >
       
      </Button>
      <TemplateModal active={active} close={!active} title={t('fileUploader.title')}>
        <CSVUploader map={props.map} callback={closeModal} />
        <ShapeUploader map={props.map} callback={closeModal} />
        <KMLUploader map={props.map} callback={closeModal} />
      </TemplateModal>
    </div>
  );
}

export default FileUploader;
